const Forbidden = () => {
  return (
    <div className='flex items-center flex-col mt-[30px]'>
      <h1 className='text-[32px]'>Forbidden</h1>
      <span className='text-center'>You&apos;re not supposed to be here...</span>
    </div>
  );
};

export default Forbidden;
